import React, {useEffect, useState, useCallback, useRef} from "react";
import {Field} from "react-final-form";
import {
    composeValidators,
    regRequiredValidate,
} from "../../../../containers/RegistrationLoginPage/registrationValidation";
import {
    FormType,
    IdLabelInterface,
    UserPreferredCountry,
} from "../../../../containers/RegistrationLoginPage/types";
import {SelectHelperText} from "../Styled";
import SelectV2 from "../../../HTMLEntities/SelectV2";
import {MULTI_SELECT, SINGLE_SELECT} from "../../../HTMLEntities/SelectV2/utils";
import {MAX_COUNTRY_LENGTH} from "../../../../containers/RegistrationLoginPage/utils";
import {errorHandler} from "../../../../containers/RegistrationLoginPage/errorUtils";

interface Props {
    configuration: UserPreferredCountry;
    removeSpan?: boolean;
    dropDownType?: typeof MULTI_SELECT | typeof SINGLE_SELECT;
    formType?: FormType;
}
const CountryField: React.FC<Props> = ({
    configuration,
    removeSpan = false,
    dropDownType = MULTI_SELECT,
    formType,
}: Props) => {
    const {fieldName, values: dropDownValues, selectedValue, editable} = configuration;
    const counsellorEdit = formType === "counsellingEditProfile";

    const getItemsList = useCallback(() => {
        const itemsList: IdLabelInterface[] = [];
        dropDownValues &&
            dropDownValues.map((section) => {
                const {groupOptions} = section;
                groupOptions.map((mainOption: IdLabelInterface) => {
                    itemsList.push(mainOption);
                });
            });
        return itemsList;
    }, [dropDownValues]);

    const [flatItems, setFlatItems] = useState<IdLabelInterface[]>(() => getItemsList());

    const isMounted = useRef(false);
    useEffect(() => {
        if (isMounted.current) {
            const itemsList: IdLabelInterface[] = getItemsList();
            setFlatItems(itemsList);
        } else {
            isMounted.current = true;
        }
    }, [getItemsList]);

    const countryFieldObjectToPlaceHolderText = useCallback(
        (countryFieldObject: IdLabelInterface[] | IdLabelInterface) => {
            const countryPlaceHolderItem: string[] = [];
            if (dropDownType === MULTI_SELECT && Array.isArray(countryFieldObject)) {
                countryFieldObject?.map((item) => countryPlaceHolderItem.push(item.label));
                return countryPlaceHolderItem.join(", ");
            } else if (!Array.isArray(countryFieldObject)) {
                return countryFieldObject.label;
            } else {
                return "";
            }
        },
        [dropDownType],
    );
    return (
        <>
            {flatItems ? (
                <>
                    <Field<IdLabelInterface[]>
                        name={fieldName}
                        validate={composeValidators(
                            regRequiredValidate("Please select preferred country"),
                        )}
                        {...(counsellorEdit
                            ? selectedValue && selectedValue.length > 1
                                ? {}
                                : {initialValue: selectedValue || []}
                            : selectedValue
                            ? {initialValue: selectedValue}
                            : {})}
                        validateFields={[]}
                    >
                        {(props) => {
                            return (
                                <SelectV2
                                    placeholder="Preferred Country"
                                    type={dropDownType}
                                    items={flatItems}
                                    isDisabled={!editable}
                                    maxSelectedLength={counsellorEdit ? 1 : MAX_COUNTRY_LENGTH}
                                    optGroupItem={dropDownValues ?? []}
                                    inputRFF={props.input}
                                    withSearch={true}
                                    isFocused={props?.meta?.active ?? false}
                                    isTouched={props?.meta?.touched ?? false}
                                    error={errorHandler(props?.meta)}
                                    selectedOption={
                                        counsellorEdit
                                            ? selectedValue && selectedValue.length > 1
                                                ? []
                                                : selectedValue || []
                                            : selectedValue
                                            ? selectedValue
                                            : undefined
                                    }
                                    withOptGroup={true}
                                    placeHolderItemToString={countryFieldObjectToPlaceHolderText}
                                    isFilled={typeof props.input.value === "object"}
                                    menuLegend={
                                        dropDownType === MULTI_SELECT
                                            ? "SELECT UPTO THREE"
                                            : "SELECT ONE"
                                    }
                                />
                            );
                        }}
                    </Field>
                    {!removeSpan && (
                        <SelectHelperText>
                            {counsellorEdit
                                ? "You can add only 1 country from the list"
                                : "You can add upto 3 countries from the list"}
                        </SelectHelperText>
                    )}
                </>
            ) : (
                ""
            )}
        </>
    );
};
export default CountryField;
